import { BgPosition } from '@components/card';

/**
 * Генерирует константы для страницы data-company
 * Переводы не требуются, так как страница доступна только для .ru
 */
export const CONFIG = {
  KEY_FEATURES: [
    {
      imgSrcKey: 'trend',
      description: '6+ тыс уникальных организаций с привязкой юридических лиц',
    },
    {
      imgSrcKey: 'folder_marker',
      description: 'Данные актуальны и обновляются в начале каждого месяца',
    },
    {
      imgSrcKey: 'database',
      buttonHref: 'https://docs.2gis.com/pro/overview',
      description: 'Базу можно купить онлайн, рассчитав стоимость за минуты',
    },
    {
      imgSrcKey: 'support',
      description:
        'Эксперт 2ГИС бесплатно поможет подобрать критерии для выборки',
    },
  ],

  INFO_CHIPS_SECTION: {
    href: 'https://disk.2gis.com/opk-2gis-site/%D0%91%D0%B0%D0%B7%D0%B0_%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85_2%D0%93%D0%98%D0%A1_%D0%BE%D1%80%D0%B3%D0%B0%D0%BD%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D0%B8.xlsx',
    buttonName: 'Скачать пример',
    chips: [
      'Название',
      'Адрес',
      'Способ оплаты',
      'Этаж',
      'Контакты',
      'Соцсети',
      'Рубрики',
      'Сайт',
      'Время работы',
      'ИНН/БИН',
      'Сотрудники',
      'Юридическое название',
      'Филиалы',
      'Средний чек',
    ],
  },

  FILE_FORMAT_CHIPS: [
    {
      id: '1',
      label: '.JSON',
      tooltip:
        'JSON — текстовый формат обмена данными, основанный на JavaScript. Это простой и надёжный формат передачи данных.',
    },
    {
      id: '2',
      label: '.XLSX',
      tooltip:
        'XLSX — формат таблиц Microsoft Excel, который организует данные в ячейках, листах и книгах. Ячейки таблиц могут содержать стили, форматирование, математические функции и другое.',
    },
    {
      id: '3',
      label: '.CSV',
      tooltip:
        'CSV — формат представления табличных данных, в котором каждая строка файла содержит данные строки таблицы. Часто используется для обмена данными между геоинформационными системами.',
    },
    {
      id: '4',
      label: '.XML',
      tooltip:
        'XML — формат для хранения структурированных данных с особой разметкой. Чаще всего применяется для обработки документов в программах.',
    },
  ],

  HOW_IT_WORKS_STEPS: [
    {
      id: 'step-1',
      stepNumber: '01',
      description: 'Заявка, заполнение формы и описание вашей задачи',
      buttonLabel: 'Заполнить',
      pcPlacement: 'bottom-left' as BgPosition,
      mobilePlacement: 'top-left' as BgPosition,
      buttonHref: 'https://dev.2gis.ru/data#form',
    },
    {
      id: 'step-2',
      stepNumber: '02',
      description:
        'Менеджер 2ГИС поможет сформировать выборку, проконсультирует и рассчитает стоимость',
      pcPlacement: 'top-right' as BgPosition,
      mobilePlacement: 'top-right' as BgPosition,
    },
    {
      id: 'step-3',
      stepNumber: '03',
      description:
        'Получение: после оплаты вы получаете ссылку на готовую базу в нужном формате на ваш e&#x2060-&#x2060mail',
      pcPlacement: 'bottom-right' as BgPosition,
      mobilePlacement: 'bottom-left' as BgPosition,
    },
  ],

  FAQ_ITEMS: [
    {
      id: 'actualData',
      title: 'Насколько актуальны данные 2ГИС?',
      content:
        'Мы обновляем базу ежемесячно. Дата последнего обновления всегда указана вверху страницы. Гарантируем актуальность не менее 95% на момент покупки.',
    },
    {
      id: 'persons',
      title: 'Можно ли получить базу по физическим лицам?',
      content: 'Нет, мы работаем исключительно с данными юридических лиц и ИП.',
    },
    {
      id: 'dataFormat',
      title: 'В каком формате можно получить базу?',
      content:
        'Можно выбрать удобные для ваших задач форматы: JSON, XLSX, CSV, XML — это общепринятые стандарты, которые, в частности, совместимы со всеми популярными CRM.',
    },
    {
      id: 'individualCases',
      title: 'Делает ли 2ГИС базы данных под индивидуальные бизнес-запросы?',
      content:
        'Да. Мы предоставляем расширенные данные об организациях, которых нет в публичном сервисе 2ГИС.',
    },
  ],
};

export const DATA_2_GIS_HREF =
  'https://data.2gis.com/?utm_source=dev.2gis.ru&utm_medium=data&utm_campaign=button1screen';
